<template>
	<form enctype="multipart/form-data" novalidate>
		<input
			ref="fileupload"
			type="file"
			:id="hiddenid"
			:disabled="isUploading"
			@change="filesChange(($event.target as HTMLInputElement)?.files)"
			:accept="fileType"
			:style="{'width': width,'height': height}"
		>
		<slot></slot>
	</form>
</template>

<script setup lang="ts">
import { useApiStore } from '@/stores/Api'
import { onMounted, ref } from 'vue'

const api = useApiStore()

interface Props {
	targetUrl: string
	property: string
	fileType: string
	onEvent?: (args: { state: string, file: string, response?: unknown }) => void
}

const props = withDefaults(defineProps<Props>(), {
	fileType: '*/*',
	onEvent: () => { /** Ignore */ }
})

const isUploading = ref(false)
const currentFile = ref('')
const width = ref('0px')
const height = ref('0px')
const hiddenid = ref(Math.random().toString())
const fileupload = ref<HTMLInputElement | null>(null)

async function upload(formData: FormData) {
	props.onEvent({ state: 'UPLOADING', file: currentFile.value })

	try {
		const res = await api.post(props.targetUrl, formData)

		props.onEvent({ state: 'COMPLETED', file: currentFile.value, response: res.data })
	}
	catch (err) {
		props.onEvent({ state: 'FAILED', file: currentFile.value, response: (err as Record<string, unknown>).data })
	}
}

function filesChange(fileList: FileList | null) {
	if (!fileList || !fileList.length) { return }
	const formData = new FormData()
	const file = fileList[0]

	if (file) {
		formData.append(props.property, file, file.name)
		currentFile.value = file.name
		upload(formData)
	}
}

function dragOver(event: DragEvent) { // eslint-disable-line
	// console.log('Drag over');
}

function dragLeave(event: DragEvent) { // eslint-disable-line
	// console.log('Drag leave');
}

onMounted(() => {
	const item = fileupload.value?.children[1] as HTMLElement
	if (item) {
		width.value = item.clientWidth + 'px'
		height.value = item.clientHeight + 'px'
	}
})
</script>

<style scoped>
	INPUT {
		position: absolute;
		z-index: 2;
		opacity: 0;
	}
</style>
